import React from 'react';

const ACCENT_COLOR = '#fec35c';
const ACCENT_SOFT = 'rgba(254, 195, 92, 0.12)';
interface AgentSuggestionProps {
  suggestion: {
    message: string;
    suggested_agent: string;
    suggested_agent_name: string;
    confidence: number;
  };
  onSwitchAgent: (agentId: string) => void;
  onDismiss: () => void;
}

const AgentSuggestionComponent: React.FC<AgentSuggestionProps> = ({
  suggestion,
  onSwitchAgent,
  onDismiss
}) => {
  return (
    <div style={{
      backgroundColor: ACCENT_SOFT,
      border: `1px solid ${ACCENT_COLOR}`,
      borderRadius: '4px',
      padding: '12px 16px',
      margin: '8px 0',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px'
      }}>
        {/* Icon */}
        <div style={{
          width: '24px',
          height: '24px',
          backgroundColor: ACCENT_COLOR,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '12px',
          flexShrink: 0,
          marginTop: '2px'
        }}>
          💡
        </div>
        
        {/* Content */}
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '500',
            color: ACCENT_COLOR,
            marginBottom: '4px'
          }}>
            Agent Suggestion
          </div>
          
          <div style={{
            fontSize: '13px',
            color: ACCENT_COLOR,
            lineHeight: '1.4',
            marginBottom: '8px'
          }}>
            {suggestion.message}
          </div>
          
          {/* Action buttons */}
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center'
          }}>
            <button
              onClick={() => onSwitchAgent(suggestion.suggested_agent)}
              style={{
                backgroundColor: ACCENT_COLOR,
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                fontSize: '12px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = ACCENT_COLOR;
                e.currentTarget.style.filter = 'brightness(0.95)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = ACCENT_COLOR;
                e.currentTarget.style.filter = 'none';
              }}
            >
              Switch to {suggestion.suggested_agent_name}
            </button>
            
            <button
              onClick={onDismiss}
              style={{
                backgroundColor: 'transparent',
                color: ACCENT_COLOR,
                border: `1px solid ${ACCENT_COLOR}`,
                borderRadius: '4px',
                padding: '6px 12px',
                fontSize: '12px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = ACCENT_SOFT;
                e.currentTarget.style.borderColor = ACCENT_COLOR;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = ACCENT_COLOR;
              }}
            >
              Dismiss
            </button>
          </div>
        </div>
        
        {/* Close button */}
        <button
          onClick={onDismiss}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            color: ACCENT_COLOR,
            cursor: 'pointer',
            fontSize: '14px',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = ACCENT_SOFT;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default AgentSuggestionComponent;
